var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeRingDetailFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 483,
    height: 483,
    viewBox: "0 0 483 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M241.5 110C168.875 110 110 168.875 110 241.5C110 314.125 168.875 373 241.5 373C314.125 373 373 314.125 373 241.5C373 168.875 314.125 110 241.5 110ZM241.5 0C108.123 0 0 108.123 0 241.5C0 374.877 108.123 483 241.5 483C374.877 483 483 374.877 483 241.5C483 108.123 374.877 0 241.5 0Z",
    fill: "#00CDD2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeRingDetailFill);
export default __webpack_public_path__ + "static/media/shape-ring-detail-fill.2caee3bc.svg";
export { ForwardRef as ReactComponent };